import trace from '~/lib/trace';
import {useEffect, useState} from 'react';
import {View, ScrollView, TextInput as RNTextInput} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {
  Text,
  Pressable,
  RadioButton,
  Modal,
  ActionButton,
} from '~/components/controls';
import {fleet as fleetApi} from '~/api/private';
import Format from '~/lib/format';
import SearchIcon from '~/images/md-icons/search/materialicons/24px.svg';

import HighlightText from './HighlightText';
import PropTypes from 'prop-types';

const VehicleSearch = ({dealer_id, visible, onDismiss, onSelect}) => {
  const [prefix, setPrefix] = useState('');
  const [selected, setSelected] = useState(null);
  const [results, setResults] = useState([]);
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const {result} = await fleetApi.contracts_by_reference(
          dealer_id,
          prefix,
        );

        setResults(result);
      } catch (error) {
        trace(error);
      }
    };

    if (prefix.length > 1) {
      fetch().catch(trace);
    } else {
      setResults([]);
    }
  }, [dealer_id, prefix]);

  return (
    <Modal
      visible={visible}
      contentContainerStyle={sy['bg-gray95']}
      onDismiss={onDismiss}>
      <View
        style={[
          {height: 64},
          sy['flex-row'],
          sy['items-center'],
          sy['p-4'],
          sy['bg-white'],
        ]}>
        <Text style={sy.largePlus}>Voertuignummer</Text>
      </View>
      <Divider style={sy['bg-gray88']} />
      <View
        style={[
          sy['flex-row'],
          sy['items-center'],
          [sy['px-4'], sy['py-3'], sy['bg-white']],
        ]}>
        <View
          style={[
            sy['flex-row'],
            sy['flex-1'],
            sy['p-2'],
            sy['items-center'],
            {
              borderRadius: 10,
              backgroundColor: '#EBEBEB',
            },
          ]}>
          <SearchIcon
            fill={prefix.length ? '#4A4A49' : '#828282'}
            width={18}
            height={18}
          />
          <RNTextInput
            style={[
              sy.regular,
              sy['flex-1'],
              {
                color: prefix?.length > 0 ? '#4A4A49' : '#828282',
                marginLeft: 28,
              },
            ]}
            placeholder={'Zoek op voertuignummer'}
            value={prefix}
            onChangeText={setPrefix}
          />
        </View>
      </View>
      <Divider style={sy['bg-gray95']} />
      <ScrollView style={[sy['flex-1']]}>
        {results.map((item) => (
          <Pressable key={item.reference} onPress={() => setSelected(item)}>
            <View style={[sy['flex-row'], sy['items-center'], sy['bg-white']]}>
              <View style={[sy['p-4']]}>
                <RadioButton checked={selected?.reference === item.reference} />
              </View>
              <View style={[sy['flex-1']]}>
                <View style={sy['p-4']}>
                  <View style={[sy['flex-row'], sy['items-center']]}>
                    <HighlightText text={item.reference} highlight={prefix} />
                  </View>
                  <Text style={[sy.small, sy['text-lightgray']]}>
                    {Format.license(item.license)}&nbsp;&middot;&nbsp;
                    {item.company_name}
                  </Text>
                </View>
                <Divider style={sy['bg-gray88']} />
              </View>
            </View>
          </Pressable>
        ))}
      </ScrollView>

      <Divider style={sy['bg-gray88']} />
      <View
        style={[
          {height: 56},
          sy['px-4'],
          sy['bg-white'],
          sy['flex-row'],
          sy['justify-end'],
          sy['items-center'],
          sy['gap-4'],
        ]}>
        <ActionButton onPress={onDismiss}>Annuleren</ActionButton>
        <ActionButton
          disabled={!selected || pressed}
          onPress={() => {
            setPressed(true);
            onSelect(selected.license);
          }}>
          OK
        </ActionButton>
      </View>
    </Modal>
  );
};
VehicleSearch.propTypes = {
  dealer_id: PropTypes.any,
  visible: PropTypes.any,
  onDismiss: PropTypes.any,
  onSelect: PropTypes.any,
};

export default VehicleSearch;
